import { render, staticRenderFns } from "./ProcedureFormsEditor.vue?vue&type=template&id=3e163dca&scoped=true"
import script from "./ProcedureFormsEditor.vue?vue&type=script&lang=js"
export * from "./ProcedureFormsEditor.vue?vue&type=script&lang=js"
import style0 from "./ProcedureFormsEditor.vue?vue&type=style&index=0&id=3e163dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e163dca",
  null
  
)

export default component.exports